import { render, staticRenderFns } from "./moderatorSelectCard.vue?vue&type=template&id=8ade70a0&scoped=true&"
import script from "./moderatorSelectCard.vue?vue&type=script&lang=js&"
export * from "./moderatorSelectCard.vue?vue&type=script&lang=js&"
import style0 from "./moderatorSelectCard.vue?vue&type=style&index=0&id=8ade70a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade70a0",
  null
  
)

export default component.exports